module.exports = __webpack_public_path__ + "static/media/nyag.6218ddca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nyag.jpg
// module id = 790
// module chunks = 0